import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WorkshopJobcardCustomQuestionDetailsComponent } from './workshop-jobcard-custom-question-details/workshop-jobcard-custom-question-details.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from 'src/app/services/helpers.service';

@Component({
  selector: 'app-workshop-jobcard-custom-questions',
  templateUrl: './workshop-jobcard-custom-questions.component.html',
  styleUrls: ['./workshop-jobcard-custom-questions.component.scss']
})
export class WorkshopJobcardCustomQuestionsComponent {

  @Input() jobcard: any = {};
  @Output() jobcardChange = new EventEmitter<any>();

  constructor(
    private modalService: NgbModal,
    private helpersService: HelpersService,
    private translate: TranslateService
  ) { }

  showCustomQuestonDetails() {
    const modalRef = this.modalService.open(WorkshopJobcardCustomQuestionDetailsComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'lg'
    });

    modalRef.componentInstance.jobcard = this.jobcard;

    modalRef.result.then(
      (result) => {
        this.jobcardChange.emit({ ...this.jobcard });
      },
      (onrejected) => {
        console.log('Modal dismissed:', onrejected);
      },
    );
  }

  getCompletedCustomQuestions() {
    var count = 0;
    if(this.jobcard?.customQuestions && this.jobcard.customQuestions.length >0) {
      this.jobcard.customQuestions.forEach((group: any) => {
        group.customQuestions.forEach((question: any) => {
          if(question.response){
            count += 1;
          }
        });
      });
    }
    return count;
  }

  getCustomQuestionCount() {
    var count = 0;
    if(this.jobcard?.customQuestions && this.jobcard.customQuestions.length >0) {
      this.jobcard.customQuestions.forEach((group: any) => {
        group.customQuestions.forEach((question: any) => {
          count += 1;
        });
      });
    }
    return count;
  }
}
